const en = {
  common: {
    home: 'Home',
    loading: 'Loading...',
    and: 'and'
  },
  language: {
    label: 'Language',
    english: 'English',
    spanish: 'Spanish',
    greek: 'Greek'
  },
  header: {
    downloadFreeVersion: 'Download Free Version',
    searchPlaceholder: 'Ctrl + K',
    wizard: 'Create Event',
    openNotifications: 'open notifications',
    notificationsTitle: 'Notifications',
    markAllReadTooltip: 'Mark all as read',
    viewAllNotifications: 'View All'
  },
  menu: {
    navigation: 'Navigation',
    dashboard: 'Dashboard',
    events: 'Events',
    people: 'People',
    upgrade: 'Upgrade',
    administrators: 'Administrators',
    users: 'Users',
    scheduled: 'Scheduled',
    queue: 'Queue',
    queueAll: 'Queue - All',
    queueCompleted: 'Queue - Completed',
    queueNotCompleted: 'Queue - Not Completed',
    queueOverdue: 'Queue - Overdue',
    queueEmail: 'Queue - Email',
    queueSms: 'Queue - SMS',
    queueViber: 'Queue - Viber',
    queueTelegram: 'Queue - Telegram',
    transactions: 'Transactions',
    emailTemplates: 'Email Templates',
    eventTemplates: 'Event Templates',
    authentication: 'Authentication',
    login: 'Login',
    register: 'Register',
    utilities: 'Utilities',
    typography: 'Typography',
    color: 'Color',
    shadow: 'Shadow',
    support: 'Support',
    samplePage: 'Sample Page',
    documentation: 'Documentation'
  },
  footer: {
    rightsReserved: 'All rights reserved',
    hireUs: 'Hire us',
    license: 'License',
    terms: 'Terms',
    figmaDesignSystem: 'Figma Design System'
  },
  dashboard: {
    title: 'Dashboard',
    apiHealth: 'API Health',
    checking: 'Checking...',
    currentUser: 'Current User',
    signedIn: 'Signed in',
    signedInAccount: 'Signed-in account',
    userRole: 'User',
    sessionInvalid: 'Session invalid',
    loginAgain: 'Please login again',
    totalOrder: 'Total Order',
    totalSales: 'Total Sales',
    totalEvents: 'Total Events',
    totalEventsDesc: 'All your events',
    totalPeople: 'Total People',
    totalPeopleDesc: 'Active people in your list',
    nextEvent: 'Next Event',
    noUpcomingEvent: 'No upcoming events',
    today: 'Today',
    days: 'days',
    incomeOverview: 'Income Overview',
    thisWeekStatistics: 'This Week Statistics',
    recentOrders: 'Recent Orders',
    recentAnswers: 'Recent Answers',
    recentAnswersTable: {
      event: 'Event',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      countPerson: 'Persons',
      status: 'Status',
      noData: 'No answers yet.',
      statusAttending: 'Attending',
      statusDeclined: 'Declined',
      statusMaybe: 'Maybe',
      statusPending: 'Pending'
    },
    exportCsv: 'Export as CSV',
    exportExcel: 'Export as Excel',
    printTable: 'Print Table',
    analyticsReport: 'Analytics Report',
    weekly: 'Weekly',
    monthly: 'Monthly',
    yearly: 'Yearly',
    financeGrowth: 'Company Finance Growth',
    expensesRatio: 'Company Expenses Ratio',
    businessRiskCases: 'Business Risk Cases',
    low: 'Low',
    transactionHistory: 'Transaction History',
    recentNotifications: 'Recent Notifications',
    noNotifications: 'No notifications yet',
    justNow: 'Just now',
    minutesAgo: '{{count}}m ago',
    hoursAgo: '{{count}}h ago',
    daysAgo: '{{count}}d ago',
    helpSupportChat: 'Help & Support Chat',
    typicalReply: 'Typical reply within 5 min',
    needHelp: 'Need Help?',
    financeOverview: 'Finance Overview',
    income: 'Income',
    expenses: 'Expenses',
    month: 'Month',
    week: 'Week',
    noFinanceData: 'Add finance data to your events to see your chart here',
    goToEvents: 'Go to Events',
    welcome: {
      heading: 'Welcome to EventList',
      subtitle: 'Everything you need to plan and manage your events — invitations, guests, tables, and finances — all in one place.',
      cta: 'Create your first event',
      step1Title: 'Create Event',
      step1Desc: 'Set up your event with a name, date, location, and all the key details.',
      step2Title: 'Add Guests',
      step2Desc: 'Build your guest list and send beautiful, personalised email invitations.',
      step3Title: 'Manage Tables',
      step3Desc: 'Assign guests to tables and organise your seating arrangement with ease.',
      step4Title: 'Track Finances',
      step4Desc: 'Log income and expenses to keep your event budget under control.'
    }
  },
  upgradePage: {
    title: 'Upgrade to Premium',
    subtitle: 'Unlock advanced features for your team with a single Premium plan.',
    discountBadge: 'Save 30%',
    returnHint: 'After successful payment, you will return to the thank-you page automatically.',
    month: 'month',
    year: 'year',
    billingMonthly: 'Monthly',
    billingYearly: 'Yearly',
    billedAnnually: 'Billed EUR {{price}} / year',
    yearlyDiscount: '30% discount on yearly plan',
    choosePlan: 'Choose Plan',
    processing: 'Redirecting to payment...',
    packages: {
      premium: 'Premium'
    },
    features: {
      unlimitedCustomers: 'Send to unlimited customers',
      unlimitedEvents: 'Create unlimited events and invitations',
      emailSmsViberTelegram: 'Email, SMS, Viber and Telegram channels',
      advancedAnalytics: 'Advanced analytics and delivery tracking',
      prioritySupport: 'Priority support with faster response time',
      multiTeamAccess: 'Multi-team access and role management'
    },
    errors: {
      loadCatalog: 'Unable to load billing plans right now.',
      planUnavailable: 'This plan is temporarily unavailable. Please try again.',
      checkoutFailed: 'Could not create checkout session. Please try again.'
    }
  },
  upgradeThankYou: {
    title: 'Thank You for Your Payment',
    subtitle: 'Your package is being confirmed. You can continue using the dashboard.',
    processing: 'Processing your payment confirmation...',
    success: 'Payment completed successfully. Your plan benefits are now active.',
    missingPaymentReference: 'No payment reference was found in the return URL.',
    backToUpgrade: 'Back to Upgrade',
    goToDashboard: 'Go to Dashboard',
    errors: {
      completeFailed: 'Payment confirmation failed. Please contact support if you were charged.'
    }
  },
  mobileCheckoutResult: {
    successTitle: 'Payment successful',
    successMessage: 'Your payment was completed. You can close this page and return to the app.',
    failedTitle: 'Payment not completed',
    failedMessage: 'Your payment was not completed or was cancelled. You can close this page and return to the app.',
    pendingTitle: 'Payment received',
    pendingMessage: 'You can close this page and return to the app.'
  },
  eventsPage: {
    title: 'Events',
    createNewEvent: 'Create New Event',
    loadingEvents: 'Loading events...',
    searchLabel: 'Search',
    searchPlaceholder: 'Search by title, type, venue, or address',
    pageSize: 'Page size',
    results: 'Showing {{shown}} of {{total}} events',
    noEvents: 'No events yet. Create your first event.',
    noEventsMatchSearch: 'No events match your search.',
    noEventsMatchFilters: 'No events match the selected send provider filters.',
    edit: 'Edit',
    view: 'View',
    createEvent: 'Create Event',
    editEvent: 'Edit Event',
    viewEvent: 'View Event',
    save: 'Save',
    saveChanges: 'Save Changes',
    cancel: 'Cancel',
    close: 'Close',
    guestsTitle: 'Guests',
    loadingGuests: 'Loading guests...',
    noGuests: 'No guests found for this event.',
    eventFallback: 'Event',
    table: {
      actions: 'Actions',
      edit: 'Edit',
      title: 'Title',
      occasion: 'Occasion',
      eventType: 'Event Type',
      status: 'Status',
      sendProviders: 'Send Methods',
      scheduledLocal: 'Scheduled (Local)',
      createdLocal: 'Created (Local)',
      venue: 'Venue',
      guests: 'Guests',
      tablesLockedForPastEvent: 'Tables are locked because this event date has passed.'
    },
    actions: 'Actions',
    manageTables: 'Tables',
    status: {
      readyToSend: 'Ready to Send',
      sending: 'Sending',
      sent: 'Sent'
    },
    sendDateMode: {
      immediately: 'Immediately',
      scheduled: 'Scheduled'
    },
    details: {
      title: 'Event Details',
      status: 'Status',
      sendDateMode: 'Send Mode',
      templateName: 'Template Name',
      totalGuests: 'Total Guests'
    },
    form: {
      title: 'Title',
      occasionType: 'Occasion Type',
      eventType: 'Event Type',
      scheduledDateTime: 'Scheduled Date & Time',
      venue: 'Venue',
      address: 'Address',
      timeZone: 'Time Zone',
      defaultLanguage: 'Default Language',
      sendProviders: 'Send Methods',
      replyBeforeDays: 'RSVP deadline (days before event)',
      replyBeforeDaysHelp: 'Number of days before the event that guests must reply by. Leave empty for no deadline.'
    },
    filters: {
      status: 'Filter by Status',
      allStatuses: 'All Statuses',
      sendProvider: 'Filter by Send Method',
      allSendProviders: 'All Send Methods',
      sortBySendProvider: 'Sort by Send Method',
      showFilters: 'Show filters',
      hideFilters: 'Hide filters',
      none: 'No Sorting',
      ascending: 'A to Z',
      descending: 'Z to A',
      tableView: 'Table View',
      cardView: 'Card View'
    },
    card: {
      template: 'Template',
      templatePreview: 'Template preview',
      noImage: 'No preview image'
    },
    pagination: {
      previous: 'Previous',
      next: 'Next',
      goToPage: 'Go to page',
      pageOf: 'Page {{page}} of {{totalPages}}'
    },
    eventTypeOptions: {
      other: 'Other',
      wedding: 'Wedding',
      birthday: 'Birthday',
      conference: 'Conference',
      meeting: 'Meeting',
      party: 'Party'
    },
    backToEvents: 'Back to Events',
    guestsTable: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      countPerson: 'Count',
      preferredLanguage: 'Language',
      status: 'Status',
      url: 'Public URL',
      copyUrl: 'Copy URL',
      copyWishlistUrl: 'Copy Wishlist Link',
      copied: 'Copied',
      resend: 'Resend',
      resending: 'Resending...',
      resendSuccess: 'Invitation resent to {{name}}.',
      log: 'Log',
      lastAnswerLocal: 'Last Answer',
      tableNumber: 'Table',
      logHistoryTitle: 'Guest Answer Log',
      logAction: 'Action',
      logActionResponded: 'Guest responded',
      logDateLocal: 'Date (Local time)',
      loadingLog: 'Loading answer history...',
      logFilter: 'Filter',
      logFilterToday: 'Today',
      logFilterLast7Days: 'Last 7 days',
      logFilterAll: 'All',
      noLogEntries: 'No answer log entries yet.',
      quickViewTitle: 'Guest Details',
      rsvpStatus: 'RSVP status',
      invitationCode: 'Invitation code',
      scanCode: 'Scan code',
      statusChanged: 'Status updated for {{name}}.',
      countPersonChanged: 'Guest count updated for {{name}}.',
      checkedIn: 'Checked in',
      addGuest: 'Add Guest',
      addGuestTitle: 'Add New Guest',
      addGuestSuccess: '{{name}} has been added as a guest.',
      sendToUnsent: 'Send to Unsent',
      sendToUnsentHint: 'Use "Send to Unsent" to send invitations to guests who were added but have not received a message yet.',
      sendToUnsentSuccess: 'Invitations sent to {{count}} unsent guest(s).',
      allAlreadySent: 'All guests have already been sent an invitation.',
      addFromContacts: 'Add from Contacts',
      addFromContactsTitle: 'Add Guests from Contacts',
      addFromContactsSuccess: '{{count}} contact(s) added as guests.',
      searchContactsPlaceholder: 'Search by name, email, or phone',
      noContactsMatch: 'No contacts match your search.',
      noContactsAvailable: 'All contacts are already added to this event.',
      contactsAvailable: '{{count}} contacts available ({{selected}} selected)',
      addSelected: 'Add {{count}} Selected',
      remove: 'Remove',
      removeGuestTitle: 'Remove Guest',
      removeGuestConfirm: 'Are you sure you want to remove {{name}} from this event? This action cannot be undone.',
      removeGuestSuccess: '{{name}} has been removed from this event.'
    },
    rsvp: {
      accepted: 'Accepted',
      rejected: 'Rejected',
      maybe: 'Maybe',
      pending: 'Pending'
    },
    errors: {
      backendUnavailable: 'Cannot reach backend API at {{baseUrl}}. Start API with: dotnet run --project src/Backend/EventList.Api',
      loadEvents: 'Unable to load events right now.',
      loadEventDetails: 'Failed to load event details.',
      loadGuests: 'Failed to load guests.',
      loadGuestLog: 'Failed to load guest answer log.',
      createEvent: 'Failed to create event.',
      updateEvent: 'Failed to update event.',
      resendInvitation: 'Failed to resend invitation.',
      resendTemplateNotFound: 'No matching template was found for this guest.',
      changeStatus: 'Failed to change guest status.',
      changeCountPerson: 'Failed to update guest count.',
      addGuest: 'Failed to add guest.',
      removeGuest: 'Failed to remove guest.'
    },
    validation: {
      titleMax: 'Title must be 120 characters or less',
      titleRequired: 'Title is required',
      occasionTypeMax: 'Occasion type must be 60 characters or less',
      occasionTypeRequired: 'Occasion type is required',
      scheduledAtRequired: 'Date and time are required',
      venueMax: 'Venue must be 160 characters or less',
      venueRequired: 'Venue is required',
      addressMax: 'Address must be 240 characters or less',
      addressRequired: 'Address is required',
      timeZoneMax: 'Time zone must be 100 characters or less',
      timeZoneRequired: 'Time zone is required',
      defaultLanguageMax: 'Language must be 10 characters or less',
      defaultLanguageRequired: 'Default language is required',
      sendProviderMax: 'Send method must be 40 characters or less',
      sendProviderRequired: 'Send method is required'
    }
  },
  tablesPage: {
    title: 'Tables',
    backToEvents: 'Back to Events',
    backToTables: 'Back to Tables',
    print: 'Print',
    printViewTitle: 'Tables Print View',
    printViewSubtitle: 'Print-friendly seating overview',
    eventDetails: 'Event details',
    detailEventName: 'Event name',
    detailEventType: 'Event type',
    detailDateLocal: 'Date (local)',
    detailVenue: 'Venue',
    detailAddress: 'Address',
    detailTimeZone: 'Time zone',
    detailDefaultLanguage: 'Default language',
    detailAssignedGuests: 'Assigned guests',
    detailAssignedPersons: 'Assigned persons',
    detailTotalTables: 'Total tables',
    noAssignedTables: 'No table assignments yet.',
    tableGuestCount: '{{count}} guests',
    tablePersonCount: '{{count}} persons',
    loading: 'Loading event tables...',
    eventFallback: 'Event',
    summary: 'Guests: {{totalGuests}}. Assigned: {{assignedGuests}}. Unassigned: {{unassignedGuests}}.',
    capacityLabel: 'Persons per table',
    countModeLabel: 'Count guests for recommendation',
    tableCountLabel: 'Tables to show',
    rsvpFilterLabel: 'Filter guests by RSVP',
    hardLockLabel: 'Hard capacity lock',
    hardLockOn: 'Enabled (block over-capacity drops)',
    hardLockOff: 'Disabled (allow temporary over-capacity)',
    applyRecommended: 'Use suggested count',
    autoAssign: 'Auto assign',
    clear: 'Clear seating',
    save: 'Save tables',
    saving: 'Saving...',
    recommendation: '{{guests}} guests / {{capacity}} per table = {{tables}} tables needed.',
    occupancy: '{{count}} / {{capacity}}',
    overCapacityWarning: 'Table capacity exceeded for table(s): {{tables}}. Reduce each table to {{capacity}} guests max.',
    lockBlocked: 'Cannot drop into table {{tableNumber}} because it is already at capacity ({{capacity}}).',
    declinedBlocked: 'Guests with RSVP status Declined cannot be assigned to tables.',
    pastEventLocked: 'Table assignments are locked because this event has already passed.',
    unassigned: 'Unassigned guests',
    emptyUnassigned: 'All guests are assigned to a table.',
    tableTitle: 'Table {{tableNumber}}',
    dropHint: 'Drag guests here',
    filteredViewHint: 'Showing {{shown}} of {{total}} guests for current filter.',
    rsvpFilter: {
      all: 'All RSVP statuses',
      attending: 'Attending',
      maybe: 'Maybe',
      pending: 'Pending',
      declined: 'Declined'
    },
    countMode: {
      all: 'All except declined',
      attendingOnly: 'Attending only'
    },
    success: {
      saved: 'Saved seating for {{count}} guests.'
    },
    errors: {
      backendUnavailable: 'Cannot reach backend API at {{baseUrl}}. Start API with: dotnet run --project src/Backend/EventList.Api',
      missingEventId: 'Missing event id in route.',
      load: 'Failed to load event tables.',
      save: 'Failed to save table assignments.'
    },
    premiumGate: {
      title: 'Premium Feature',
      description: 'Table management is available for Premium subscribers only. Upgrade your plan to access seating assignments and table management.',
      upgrade: 'Upgrade to Premium'
    },
    invitationGate: {
      title: 'Invitations Not Sent Yet',
      description: 'Table management will be available once invitations have been sent. First send the invitations and then you will be able to manage table assignments.'
    }
  },
  wizardPage: {
    title: 'Create Event Wizard',
    loading: 'Loading wizard data...',
    steps: {
      createEvent: 'Create Event',
      selectTemplate: 'Select Template',
      selectPeople: 'Select People',
      preview: 'Preview',
      confirmAndSend: 'Confirm And Send'
    },
    actions: {
      backToEvents: 'Back To Events',
      back: 'Back',
      next: 'Next'
    },
    form: {
      title: 'Event title',
      occasionType: 'Occasion type',
      eventType: 'Event type',
      status: 'Status',
      scheduledDateTime: 'Scheduled date and time',
      sendDateMode: 'Send date',
      sendDateTime: 'Send date and time',
      sendProviders: 'Send methods',
      venue: 'Venue',
      address: 'Address',
      defaultLanguage: 'Default language',
      timeZone: 'Time zone',
      replyBeforeDays: 'RSVP deadline (days before event)',
      replyBeforeDaysHelp: 'Number of days before the event that guests must reply by. Leave empty for no deadline.'
    },
    status: {
      readyToSend: 'Ready to Send',
      sending: 'Sending',
      sent: 'Sent'
    },
    sendDateMode: {
      immediately: 'Immediately',
      scheduled: 'Schedule date and time'
    },
    templates: {
      noPhoto: 'No photo',
      previewAlt: 'Template preview image',
      language: 'Language',
      photoSchema: 'Photo schema: 200px x 200px',
      filterEventType: 'Filter by event type',
      filterLanguage: 'Filter by language',
      all: 'All',
      other: 'Other',
      noResultsForFilters: 'No templates match the selected filters.'
    },
    table: {
      select: 'Select',
      action: 'Action',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      countPerson: 'People Count'
    },
    people: {
      createPerson: 'Create Person',
      editPerson: 'Quick Edit',
      importAvailability: 'Import Availability (Excel)',
      selectAll: 'Select All',
      deselectAll: 'Deselect All',
      dialogTitle: 'Create Person',
      editDialogTitle: 'Edit Person',
      fullNameLabel: 'Full Name',
      emailLabel: 'Email',
      phoneLabel: 'Phone',
      availabilityLabel: 'Availability',
      countPersonLabel: 'People Count',
      availabilityPlaceholder: 'Example: Mon-Fri 09:00-18:00',
      importDialog: {
        title: 'Import Availability from Excel',
        description: 'Upload an Excel file to create or update people and their availability in bulk.',
        supportedColumns: 'Supported columns and aliases are listed below.',
        columnFullName: 'Full Name (or Name)',
        columnEmail: 'Email',
        columnPhone: 'Phone (or Phone Number)',
        columnAvailability: 'Availability (or Available)',
        columnCountPerson: 'Count Person (or Count / People Count / Persons)',
        downloadDemo: 'Download Demo Excel',
        chooseFile: 'Choose Excel File',
        changeFile: 'Change File',
        selectedFile: 'Selected File',
        noFileSelected: 'No file selected',
        progressText: 'Importing row {{current}} of {{total}}',
        resultSummary: 'Import results: added {{added}}, updated {{updated}}, skipped {{skipped}}, failed {{failed}}.',
        rowErrorsTitle: 'Row-level errors',
        rowErrorItem: 'Row {{row}}: {{message}}',
        downloadErrors: 'Export Error Rows',
        skippedRowsTitle: 'Skipped rows',
        skippedRowsSummary: '{{count}} rows were skipped because both Full Name and Email were empty.',
        skippedReason: 'Missing both Full Name and Email',
        downloadSkippedRows: 'Export Skipped Rows',
        cancel: 'Cancel',
        import: 'Import',
        importing: 'Importing...'
      },
      cancel: 'Cancel',
      save: 'Save',
      create: 'Create',
      saving: 'Saving...',
      creating: 'Creating...',
      success: {
        personCreated: 'Person created and selected successfully.',
        personUpdated: 'Person updated successfully.',
        importComplete: 'Excel import complete. Added {{added}}, updated {{updated}}.'
      },
      errors: {
        createPerson: 'Failed to create person.',
        updatePerson: 'Failed to update person.',
        fullNameEmailRequired: 'Full name and email are required.',
        invalidEmail: 'Please enter a valid email address.',
        importFailed: 'Could not import this file. Please upload a valid .xlsx or .xls file.',
        importApiError: 'Failed to import people from Excel.',
        fileRequired: 'Please choose an Excel file to import.',
        emptyFile: 'The selected Excel file is empty.'
      }
    },
    preview: {
      eventSummary: 'Event Summary',
      title: 'Title',
      occasion: 'Occasion',
      eventType: 'Event type',
      when: 'When',
      status: 'Status',
      sendDateMode: 'Send date',
      sendDateTime: 'Send date and time',
      venue: 'Venue',
      address: 'Address',
      timeZone: 'Time zone',
      defaultLanguage: 'Default language',
      sendProviders: 'Send methods',
      selectedTemplate: 'Selected Template',
      previewInvitation: 'Preview Invitation',
      closePreview: 'Close Preview',
      noTemplateSelected: 'No template selected',
      recipients: 'Recipients',
      peopleSelected: '{{count}} people selected',
      countPersonSelected: '{{count}} total attendees selected'
    },
    confirm: {
      description: 'Ready to create the event, attach selected people as guests, and send invitations.',
      confirmAndSend: 'Confirm And Send',
      eventId: 'Event id'
    },
    warnings: {
      noTemplates: 'No invitation templates found. Create at least one template first so the wizard can send invitations.',
      noPeople: 'No people found. Add people first from the People page.'
    },
    validation: {
      titleRequired: 'Event title is required.',
      occasionTypeRequired: 'Occasion type is required.',
      eventTypeRequired: 'Event type is required.',
      scheduledRequired: 'Scheduled date and time is required.',
      sendDateRequired: 'Send date and time is required when schedule mode is selected.',
      venueRequired: 'Venue is required.',
      addressRequired: 'Address is required.',
      timeZoneRequired: 'Time zone is required.',
      sendProviderRequired: 'Send method is required.',
      templateRequired: 'Please select a template.',
      peopleRequired: 'Please select at least one person.'
    },
    errors: {
      backendUnavailable: 'Cannot reach backend API. Please verify EventList.Api is running.',
      loadTemplates: 'Failed to load templates.',
      loadPeople: 'Failed to load people.',
      loadWizardData: 'Failed to load wizard data.',
      createEvent: 'Failed to create event.',
      updateEvent: 'Failed to update event.',
      eventIdMissing: 'Event API did not return an event id.',
      addGuests: 'Failed to add selected people as guests.',
      sendInvitations: 'Failed to send invitations.',
      completeWizard: 'Failed to complete wizard.'
    },
    success: {
      sent: 'Invitations were sent successfully.',
      scheduled: 'Event is readyToSend. Invitations are scheduled for {{sendAt}}.',
      queuedScheduled: 'Thank you! Your message has been queued and will be sent on {{sendAt}}.',
      queuedImmediately: 'Thank you! Your message has been queued and will be sent immediately.'
    }
  },
  publicInvitation: {
    title: 'Invitation',
    loading: 'Loading invitation...',
    welcome: 'Hello {{guestName}}',
    eventTitle: 'Event',
    occasion: 'Occasion',
    scheduled: 'Date and time',
    venue: 'Venue',
    address: 'Address',
    currentResponse: 'Current response',
    answerPrompt: 'Please choose your response',
    responseSaved: 'Your response has been saved.',
    viewWishlist: 'View gift wishlist',
    actions: {
      agree: 'Agree',
      dontKnow: "I don't know",
      reject: 'Reject'
    },
    countPersonDialog: {
      title: 'How many people?',
      description: 'Please enter the total number of people attending (including yourself).',
      confirm: 'Confirm',
      cancel: 'Cancel'
    },
    errors: {
      backendUnavailable: 'Cannot reach backend API at {{baseUrl}}. Start API with: dotnet run --project src/Backend/EventList.Api',
      invalidInvitation: 'This invitation link is invalid or expired.',
      loadInvitation: 'Unable to load invitation right now.',
      submitRsvp: 'Unable to submit your response right now.'
    }
  },
  auth: {
    login: {
      title: 'Login',
      noAccount: "Don't have an account?",
      emailLabel: 'Email Address',
      emailPlaceholder: 'Enter email address',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Enter password',
      keepSignedIn: 'Keep me sign in',
      forgotPassword: 'Forgot Password?',
      button: 'Login',
      invalidCredentials: 'Invalid email or password.',
      unableToLogin: 'Unable to login right now. Please try again.'
    },
    forgotPassword: {
      title: 'Forgot Password',
      backToLogin: 'Back to login',
      emailLabel: 'Email Address',
      emailPlaceholder: 'Enter email address',
      button: 'Send Reset Link',
      success: 'If the email exists, a reset link has been sent.',
      error: 'Unable to send reset link right now. Please try again.'
    },
    resetPassword: {
      title: 'Reset Password',
      backToLogin: 'Back to login',
      passwordLabel: 'New Password',
      passwordPlaceholder: 'Enter new password',
      confirmPasswordLabel: 'Confirm Password',
      confirmPasswordPlaceholder: 'Re-enter new password',
      button: 'Reset Password',
      success: 'Your password has been reset successfully. You can now log in.',
      error: 'Unable to reset password right now. The link may have expired.',
      invalidToken: 'Invalid or missing reset token. Please request a new reset link.',
      confirmPasswordRequired: 'Please confirm your password',
      passwordsMustMatch: 'Passwords must match'
    },
    confirmEmail: {
      title: 'Confirm your email address',
      backToLogin: 'Back to login',
      instructions: 'Click the button below to confirm your email address.',
      button: 'Confirm Email Address',
      successTitle: 'Thank you!',
      successMessage: 'Your email address has been confirmed. You can now sign in.',
      checkInboxTitle: 'Check your inbox',
      checkInboxMessage: 'We sent you a confirmation link. Open it to verify your email address.',
      checkInboxEmail: 'Confirmation email sent to: {{email}}',
      error: 'Unable to confirm your email right now. The link may be invalid or expired.'
    },
    register: {
      title: 'Sign up',
      haveAccount: 'Already have an account?',
      firstNameLabel: 'First Name*',
      lastNameLabel: 'Last Name*',
      phoneLabel: 'Phone Number',
      emailLabel: 'Email Address*',
      passwordLabel: 'Password',
      confirmPasswordLabel: 'Confirm Password',
      firstNamePlaceholder: 'John',
      lastNamePlaceholder: 'Doe',
      countryCodePlaceholder: '+1',
      phonePlaceholder: '5551234567',
      emailPlaceholder: 'demo@company.com',
      agreeText: 'By Signing up, you agree to our',
      termsOfService: 'Terms of Service',
      privacyPolicy: 'Privacy Policy',
      button: 'Create Account',
      unableToRegister: 'Unable to create your account right now. Please try again.',
      emailAlreadyExists: 'An account with this email already exists. Please login instead.',
      goToLogin: 'Go to Login',
      successToast: 'Account created. Check your email to confirm your address.',
      welcome: {
        defaultName: 'there',
        title: 'Welcome, {{firstName}}',
        instructions: {
          line1: 'Your account is ready and you can now start organizing events.',
          line2: 'Use the dashboard to create events, manage guests, and track responses.',
          line3: 'If this is your first visit, begin with the default dashboard overview.'
        },
        goToDashboard: 'Go To Admin Dashboard'
      }
    },
    validation: {
      mustBeValidEmail: 'Must be a valid email',
      emailRequired: 'Email is required',
      passwordRequired: 'Password is required',
      passwordNoSpaces: 'Password cannot start or end with spaces',
      passwordTooLongLogin: 'Password must be less than 100 characters',
      passwordTooLongRegister: 'Password must be less than 10 characters',
      firstNameRequired: 'First Name is required',
      lastNameRequired: 'Last Name is required',
      confirmPasswordRequired: 'Please confirm your password',
      passwordsMustMatch: 'Passwords must match'
    }
  },
  profile: {
    title: 'Profile',
    aria: {
      openProfile: 'open profile',
      profileUserAlt: 'profile user',
      profileTabs: 'profile tabs'
    },
    defaults: {
      adminUser: 'Admin User',
      administrator: 'Administrator'
    },
    tabs: {
      profile: 'Profile',
      setting: 'Setting'
    },
    menu: {
      editProfile: 'Edit Profile',
      viewProfile: 'View Profile',
      socialProfile: 'Social Profile',
      billing: 'Billing',
      billingHistory: 'Charge History',
      renewSubscription: 'Renew Subscription',
      logout: 'Logout'
    },
    settingMenu: {
      support: 'Support',
      accountSettings: 'Account Settings',
      privacyCenter: 'Privacy Center',
      feedback: 'Feedback',
      history: 'History'
    },
    fields: {
      email: 'Email',
      role: 'Role',
      firstName: 'First Name',
      lastName: 'Last Name',
      fullName: 'Full Name',
      birthday: 'Birthday',
      invoiceEnabled: 'I need invoice details',
      invoiceCompanyName: 'Company / Invoice Name',
      invoiceVatNumber: 'VAT Number',
      invoiceAddressLine1: 'Address Line 1',
      invoiceAddressLine2: 'Address Line 2',
      invoiceCity: 'City',
      invoicePostalCode: 'Postal Code',
      invoiceCountry: 'Country'
    },
    edit: {
      title: 'Edit Profile',
      subtitle: 'Update your personal information and optional invoice details.',
      successSaved: 'Profile saved successfully.',
      currentDisplayName: 'Current display name: {{name}}',
      actions: {
        save: 'Save Profile',
        reset: 'Reset',
        viewProfile: 'View Profile',
        backToDashboard: 'Back to Dashboard'
      }
    },
    view: {
      title: 'View Profile',
      accountLoadError: 'Unable to load account data from server.',
      invoiceNotEnabled: 'Invoice details are not enabled.',
      sections: {
        account: 'Account',
        personalInformation: 'Personal Information',
        invoiceDetails: 'Invoice Details'
      },
      actions: {
        editProfile: 'Edit Profile',
        backToDashboard: 'Back to Dashboard',
        refreshLocalData: 'Refresh Local Data'
      },
      deleteAccount: {
        button: 'Delete Account',
        dialogTitle: 'Delete your account?',
        warning: 'This will permanently delete your account, events, and all associated data. This cannot be undone.',
        sendCode: 'Send deletion code',
        codePrompt: 'Enter the 6-digit code sent to your email',
        codePlaceholder: '000000',
        confirmDeletion: 'Confirm Deletion',
        resendCode: 'Resend code',
        resendCooldown: 'Resend in {{seconds}}s',
        cancel: 'Cancel'
      }
    }
  },
  billingHistoryPage: {
    title: 'Charge History',
    subtitle: 'Review your billing status and recent charge activity.',
    loading: 'Loading billing data...',
    comingSoon: 'Detailed charge history coming soon',
    note: 'You can renew your subscription now and detailed invoice rows will appear here once transaction history endpoint is available.',
    yes: 'Yes',
    no: 'No',
    summary: {
      premiumAccess: 'Premium Access',
      premiumUntil: 'Premium Until',
      smsCredits: 'SMS Credits',
      maxGuests: 'Max Guests / Event',
      smsEnabled: 'SMS Enabled'
    },
    actions: {
      renewSubscription: 'Renew Subscription',
      backToDashboard: 'Back to Dashboard'
    },
    errors: {
      load: 'Unable to load billing status right now.'
    }
  },
  adminTransactionsPage: {
    title: 'All Transactions',
    subtitle: 'Administrators can review billing transactions across all users.',
    loading: 'Loading transactions...',
    empty: 'No transactions found yet.',
    noMatches: 'No transactions match the current filters.',
    filters: {
      status: 'Status',
      allStatuses: 'All statuses',
      userEmail: 'User email',
      userEmailPlaceholder: 'Search by email',
      createdFrom: 'Created from',
      createdTo: 'Created to',
      sort: 'Sort',
      pageSize: 'Page size',
      clear: 'Clear',
      results: 'Showing {{shown}} of {{total}} transactions'
    },
    sort: {
      createdDesc: 'Newest first',
      createdAsc: 'Oldest first',
      toggleToNewest: 'Sort by newest first',
      toggleToOldest: 'Sort by oldest first'
    },
    pagination: {
      previous: 'Previous',
      next: 'Next',
      pageOf: 'Page {{page}} of {{totalPages}}'
    },
    status: {
      pending: 'Pending',
      completed: 'Completed',
      failed: 'Failed'
    },
    table: {
      created: 'Created',
      user: 'User',
      plan: 'Plan',
      amount: 'Amount',
      status: 'Status',
      completed: 'Completed',
      externalPaymentId: 'External Payment ID',
      transactionId: 'Transaction ID'
    },
    errors: {
      backendUnavailable: 'Cannot reach backend API at {{baseUrl}}. Start API with: dotnet run --project src/Backend/EventList.Api',
      load: 'Unable to load transactions right now.'
    }
  },
  notificationsPage: {
    title: 'All Notifications',
    description: 'This page uses the same notification template as the header popover so more notification types can be added later.',
    unreadCount: '{{count}} unread',
    noMatches: 'No notifications match this filter.',
    filters: {
      all: 'All',
      unread: 'Unread',
      rsvp: 'RSVP',
      billing: 'Billing',
      invitations: 'Invitations',
      newUsers: 'New users',
      newEvents: 'New events'
    },
    actions: {
      markAllRead: 'Mark all read',
      delete: 'Delete',
      cancel: 'Cancel'
    },
    deleteOptions: {
      deleteAll: 'Delete All',
      deleteOlder1Month: 'Delete older 1 month',
      deleteOlder3Months: 'Delete older 3 months',
      deleteOlder6Months: 'Delete older 6 months'
    },
    deleteDialog: {
      title: 'Confirm delete action',
      message: 'This will apply: {{action}}. You cannot undo this action.',
      confirm: 'Confirm: {{action}}'
    }
  },
  emailTemplates: {
    title: 'Email Templates',
    newTemplate: 'New Template',
    adminOnly: 'This page is available only for administrators.',
    sendTestEmail: 'Send Test Email',
    filterByType: 'Filter by type',
    filterByLanguage: 'Filter by language',
    all: 'All',
    search: 'Search',
    searchPlaceholder: 'Type, subject, body',
    loading: 'Loading templates...',
    noTemplates: 'No templates match the current filters.',
    edit: 'Edit',
    table: {
      action: 'Action',
      type: 'Type',
      language: 'Language',
      subject: 'Subject'
    },
    dialog: {
      saveTitle: 'Save Email Template',
      testTitle: 'Send Test Email',
      typeLabel: 'Type',
      languageLabel: 'Language',
      languageHelper: 'Choose template language',
      subjectLabel: 'Subject',
      bodyLabel: 'Body (HTML)',
      bodyHelper: 'Supported placeholders: {{Email}}, {{Token}}, {{ConfirmationLink}}, {{ResetLink}}, {{EventTitle}}, {{EventDate}}, {{EventLink}}',
      livePreview: 'Live preview',
      previewCaption: 'Preview uses sample values so you can verify placeholders before saving.',
      toEmailLabel: 'To email',
      templateTypeLabel: 'Template type',
      testLanguageHelper: 'Select which localized template version to send',
      cancel: 'Cancel',
      save: 'Save',
      send: 'Send'
    },
    success: {
      saved: 'Email template saved successfully.',
      testSent: 'Test email sent to {{toEmail}}.'
    },
    errors: {
      backendUnavailable: 'Cannot reach backend API at {{baseUrl}}. Start API with: dotnet run --project src/Backend/EventList.Api',
      load: 'Failed to load email templates.',
      save: 'Failed to save email template.',
      sendTest: 'Failed to send test email.',
      subjectBodyRequired: 'Subject and body are required.',
      recipientRequired: 'Recipient email is required.',
      invalidEmail: 'Please enter a valid email address.'
    }
  },
  eventTemplates: {
    title: 'Event Templates',
    newTemplate: 'New Template',
    adminOnly: 'This page is available only for administrators.',
    filterByLanguage: 'Filter by language',
    all: 'All',
    search: 'Search',
    searchPlaceholder: 'Type, name, body',
    loading: 'Loading templates...',
    noTemplates: 'No templates match the current filters.',
    edit: 'Edit',
    translate: 'Translate',
    preview: 'Preview',
    previewDialog: {
      title: 'Template Preview',
      close: 'Close'
    },
    table: {
      action: 'Action',
      name: 'Name',
      type: 'Type',
      language: 'Language',
      translations: 'Translations',
      completeness: 'Completeness',
      complete: 'Complete',
      incomplete: 'Incomplete',
      preview: 'Preview',
      created: 'Created'
    },
    translateDialog: {
      title: 'Translate Template',
      sourceTemplate: 'Source Template',
      targetLanguage: 'Target Language',
      noLanguagesAvailable: 'All languages have translations for this template.',
      save: 'Save Translation',
      cancel: 'Cancel'
    },
    dialog: {
      saveTitle: 'Save Event Template',
      typeLabel: 'Event Type',
      nameLabel: 'Name',
      languageLabel: 'Language',
      emailBodyLabel: 'Email Body (HTML)',
      invitationBodyLabel: 'Invitation Page Body (HTML)',
      invitationBodyHelper:
        'Used for the public invitation page (/i/{code}) with RSVP actions. Supported placeholders: {{GuestName}}, {{EventTitle}}, {{EventDateUtc}}, {{Venue}}, {{Address}}, {{InvitationLink}}, {{ScanCode}}, {{TableNumber}}',
      bodyHelper: 'Supported placeholders: {{GuestName}}, {{EventTitle}}, {{EventDateUtc}}, {{Venue}}, {{Address}}, {{InvitationLink}}, {{ScanCode}}, {{TableNumber}}',
      smsBodyLabel: 'SMS Body (plain text)',
      smsBodyHelper: 'Optional SMS version with a short limit ({{current}}/{{max}}). Placeholders are supported.',
      previewImageLabel: 'Preview image URL',
      previewImagePlaceholder: 'Upload an image to fill this URL',
      previewImageHelper: 'Upload an image to generate the preview URL for this template.',
      uploadPreviewImage: 'Upload preview image',
      uploadingPreviewImage: 'Uploading...',
      removePreviewImage: 'Remove image',
      livePreview: 'Live preview',
      emailPreviewTitle: 'Email preview',
      invitationPreviewTitle: 'Invitation page preview',
      invitationEditHint: 'Click any highlighted text or photo below to edit it directly — changes are saved when you click Save.',
      invitationPreviewModeHint: 'This is exactly what a guest will see — no edit controls, hidden sections are fully removed.',
      editorModeEdit: 'Edit',
      editorModePreview: 'Final preview',
      openPalette: 'Palette',
      paletteDrawerTitle: 'Color palette',
      openInNewWindow: 'Open in new window',
      tabInvitation: 'Invitation page',
      tabEmail: 'Email',
      tabSms: 'SMS',
      smsPreviewTitle: 'SMS preview',
      emptyPreview: 'No content yet.',
      previewCaption: 'Preview uses sample values so you can verify placeholders before saving.',
      cancel: 'Cancel',
      save: 'Save'
    },
    typeOptions: {
      other: 'Other',
      wedding: 'Wedding',
      birthday: 'Birthday',
      conference: 'Conference',
      meeting: 'Meeting',
      party: 'Party'
    },
    success: {
      saved: 'Event template saved successfully.',
      translated: 'Translation saved successfully.'
    },
    errorDialog: {
      title: 'Error',
      close: 'Close'
    },
    errors: {
      backendUnavailable: 'Cannot reach backend API at {{baseUrl}}. Start API with: dotnet run --project src/Backend/EventList.Api',
      load: 'Failed to load event templates.',
      save: 'Failed to save event template.',
      uploadImage: 'Failed to upload preview image.',
      uploadGalleryImage: 'Failed to upload photo.',
      popupBlocked: 'Your browser blocked the new window. Allow pop-ups for this site and try again.',
      nameBodyRequired: 'Name and body are required.',
      nameEmailInvitationRequired: 'Name, email body, and invitation body are required.',
      smsBodyTooLong: 'SMS body cannot exceed {{max}} characters.',
      translate: 'Failed to save translation.'
    }
  },
  usersPage: {
    title: 'Users',
    createUser: 'Create User',
    adminOnly: 'This page is available only for administrators.',
    loading: 'Loading users...',
    noUsers: 'No users found.',
    view: 'View',
    edit: 'Edit',
    yes: 'Yes',
    no: 'No',
    table: {
      action: 'Action',
      email: 'Email',
      role: 'Role',
      language: 'Language',
      timeZone: 'Time Zone',
      emailConfirmed: 'Email Confirmed',
      created: 'Created',
      lastLogin: 'Last Login'
    },
    createDialog: {
      title: 'Create User',
      emailLabel: 'Email',
      passwordLabel: 'Password',
      roleLabel: 'Role',
      preferredLanguageLabel: 'Preferred Language',
      timeZoneLabel: 'Time Zone',
      cancel: 'Cancel',
      create: 'Create'
    },
    editDialog: {
      title: 'Edit User',
      emailLabel: 'Email',
      roleLabel: 'Role',
      preferredLanguageLabel: 'Preferred Language',
      timeZoneLabel: 'Time Zone',
      emailConfirmedLabel: 'Email Confirmed',
      cancel: 'Cancel',
      save: 'Save'
    },
    viewDialog: {
      title: 'User Details',
      email: 'Email',
      role: 'Role',
      preferredLanguage: 'Preferred Language',
      timeZone: 'Time Zone',
      emailConfirmed: 'Email Confirmed',
      created: 'Created',
      lastLogin: 'Last Login',
      userId: 'User Id',
      loadingDetails: 'Loading user details...',
      close: 'Close'
    },
    success: {
      created: 'User created successfully.',
      updated: 'User updated successfully.'
    },
    errors: {
      backendUnavailable: 'Cannot reach backend API at {{baseUrl}}. Start API with: dotnet run --project src/Backend/EventList.Api',
      load: 'Failed to load users.',
      create: 'Failed to create user.',
      update: 'Failed to update user.',
      loadDetails: 'Failed to load user details.',
      emailPasswordRequired: 'Email and password are required.',
      emailRequired: 'Email is required.',
      invalidEmail: 'Please enter a valid email address.'
    }
  },
  scheduledPage: {
    title: 'Queue',
    adminOnly: 'This page is available only for administrators.',
    refresh: 'Refresh',
    loading: 'Loading schedules...',
    noSchedules: 'No queue items found.',
    allModesHint: 'This page includes both immediate and scheduled events with their live queue and delivery statuses.',
    nextSchedulerRun: 'Next scheduler run',
    everyMinutes: 'every {{count}} minute(s)',
    timeZoneDisplay: 'Times shown in {{timeZone}}',
    summary: {
      total: 'Total',
      completed: 'Completed',
      notCompleted: 'Not completed',
      overdue: 'Overdue',
      queuedNow: 'Queued now',
      scheduledMode: 'Scheduled mode',
      immediateMode: 'Immediate mode',
      sending: 'Sending'
    },
    status: {
      completed: 'Completed',
      notCompleted: 'Not completed',
      overdue: 'Overdue'
    },
    queueState: {
      queued: 'Queued',
      idle: 'Idle'
    },
    sendDateMode: {
      scheduled: 'Scheduled',
      immediately: 'Immediately'
    },
    retry: {
      action: 'Retry now',
      running: 'Retrying...',
      success: 'Retry queued for "{{title}}".',
      failed: 'Failed to retry this event.',
      disabled: {
        completed: 'This event is already completed.',
        sending: 'Delivery is already in progress for this event.',
        eventPassed: 'Retry now is only available before the event date/time.'
      }
    },
    filter: {
      label: 'Filter',
      options: {
        all: 'All',
        completed: 'Completed',
        notCompleted: 'Not completed',
        overdue: 'Overdue',
        queuedNow: 'Queued now',
        sending: 'Sending'
      }
    },
    providerFilter: {
      label: 'Filter by Send Method',
      all: 'All Send Methods'
    },
    sort: {
      label: 'Sort by',
      options: {
        nextRunAsc: 'Next run (earliest first)',
        nextRunDesc: 'Next run (latest first)',
        scheduledAsc: 'Scheduled at (earliest first)',
        scheduledDesc: 'Scheduled at (latest first)',
        lastSentDesc: 'Last sent (newest first)',
        lastAttemptDesc: 'Last attempt (newest first)',
        createdDesc: 'Created at (newest first)',
        createdAsc: 'Created at (oldest first)'
      }
    },
    table: {
      eventTitle: 'Event',
      completed: 'Completion',
      status: 'Status',
      queueState: 'Queue',
      sendDateMode: 'Send mode',
      sendProviders: 'Send Methods',
      scheduledAt: 'Scheduled at',
      nextRun: 'Next run',
      lastAttemptAt: 'Last attempt',
      lastSentAt: 'Last sent',
      deliveryCounts: 'Delivery counts',
      deliveryCountsValue: 'Sent: {{sent}} | Failed: {{failed}} | Pending: {{pending}}',
      createdAt: 'Created at',
      actions: 'Actions'
    },
    errors: {
      backendUnavailable: 'Cannot reach backend API at {{baseUrl}}. Start API with: dotnet run --project src/Backend/EventList.Api',
      load: 'Failed to load scheduled items.'
    }
  },
  peoplePage: {
    title: 'People',
    importAvailability: 'Import Availability (Excel)',
    createPerson: 'Create Person',
    active: 'Active',
    archived: 'Archived',
    searchLabel: 'Search',
    searchPlaceholder: 'Search by name, email, or phone',
    pageSize: 'Page size',
    results: 'Showing {{shown}} of {{total}} people',
    noMatches: 'No people match your search.',
    loading: 'Loading {{view}} people...',
    noArchivedPeople: 'No archived people yet.',
    noPeople: 'No people yet. Create one person or import availability from an Excel file.',
    edit: 'Edit',
    archive: 'Archive',
    restore: 'Restore',
    table: {
      action: 'Action',
      fullName: 'Full Name',
      email: 'Email',
      phone: 'Phone',
      availability: 'Availability',
      countPerson: 'People Count',
      archivedAt: 'Archived At'
    },
    dialog: {
      createTitle: 'Create Person',
      editTitle: 'Edit Person',
      fullNameLabel: 'Full Name',
      emailLabel: 'Email',
      phoneLabel: 'Phone',
      availabilityLabel: 'Availability',
      countPersonLabel: 'People Count',
      availabilityPlaceholder: 'Example: Mon-Fri 09:00-18:00',
      cancel: 'Cancel',
      save: 'Save',
      create: 'Create'
    },
    importDialog: {
      title: 'Import Availability from Excel',
      description: 'Upload an Excel file to create or update people and their availability in bulk.',
      supportedColumns: 'Supported columns and aliases are listed below.',
      columnFullName: 'Full Name (or Name)',
      columnEmail: 'Email',
      columnPhone: 'Phone (or Phone Number)',
      columnAvailability: 'Availability (or Available)',
      columnCountPerson: 'Count Person (or Count / People Count / Persons)',
      downloadDemo: 'Download Demo Excel',
      chooseFile: 'Choose Excel File',
      changeFile: 'Change File',
      selectedFile: 'Selected File',
      noFileSelected: 'No file selected',
      progressText: 'Importing row {{current}} of {{total}}',
      resultSummary: 'Import results: added {{added}}, updated {{updated}}, skipped {{skipped}}, failed {{failed}}.',
      rowErrorsTitle: 'Row-level errors',
      rowErrorItem: 'Row {{row}}: {{message}}',
      downloadErrors: 'Export Error Rows',
      skippedRowsTitle: 'Skipped rows',
      skippedRowsSummary: '{{count}} rows were skipped because both Full Name and Email were empty.',
      skippedReason: 'Missing both Full Name and Email',
      downloadSkippedRows: 'Export Skipped Rows',
      cancel: 'Cancel',
      import: 'Import',
      importing: 'Importing...'
    },
    confirmArchive: 'Archive {{name}}?',
    confirmRestore: 'Restore {{name}}?',
    success: {
      archived: 'Person archived successfully.',
      restored: 'Person restored successfully.',
      created: 'Person created successfully.',
      updated: 'Person updated successfully.',
      importComplete: 'Excel import complete. Added {{added}}, updated {{updated}}.'
    },
    errors: {
      backendUnavailable: 'Cannot reach backend API at {{baseUrl}}. Start API with: dotnet run --project src/Backend/EventList.Api',
      load: 'Unable to load people right now.',
      loadArchived: 'Unable to load archived people right now.',
      archive: 'Failed to archive person.',
      restore: 'Failed to restore person.',
      create: 'Failed to create person.',
      update: 'Failed to update person.',
      importFailed: 'Could not import this file. Please upload a valid .xlsx or .xls file.',
      importApiError: 'Failed to import people from Excel.',
      fileRequired: 'Please choose an Excel file to import.',
      emptyFile: 'The selected Excel file is empty.',
      fullNameEmailRequired: 'Full name and email are required.',
      invalidEmail: 'Please enter a valid email address.'
    },
    freeLimit: {
      reached: 'You have reached the 50-person limit for the free plan. Upgrade to Premium for unlimited access.',
      upgradeButton: 'Upgrade to Premium'
    },
    pagination: {
      previous: 'Previous',
      next: 'Next',
      goToPage: 'Go to page',
      pageOf: 'Page {{page}} of {{totalPages}}'
    }
  },
  financePage: {
    title: 'Finance',
    financeButton: 'Finance',
    premiumRequired: 'Event Finance is a Premium feature',
    premiumDescription: 'Track income, expenses, and profit/loss for your events. Link gifts to guests, compare planned vs actual, and see financial summaries — all in one place.',
    upgradeNow: 'Upgrade Now',
    total: 'Total',
    entries: 'entries',
    save: 'Save',
    cancel: 'Cancel',
    confirmDelete: 'Are you sure you want to delete this entry?',
    tabs: {
      budget: 'Budget',
      income: 'Income',
      expenses: 'Expenses',
      summary: 'Summary'
    },
    budget: {
      title: 'Event Budget',
      plannedIncome: 'Planned Income',
      plannedExpenses: 'Planned Expenses',
      expectedGuests: 'Expected Guests',
      expectedAttendees: 'Expected Attendees',
      notes: 'Notes',
      save: 'Save Budget',
      saved: 'Budget saved successfully',
      plannedProfit: 'Planned Profit'
    },
    income: {
      title: 'Income',
      addIncome: 'Add Income',
      editIncome: 'Edit Income',
      noEntries: 'No income entries yet.',
      category: 'Category',
      amount: 'Amount',
      description: 'Description',
      guest: 'Guest',
      receivedAt: 'Received At',
      anonymous: 'Anonymous Gift',
      groupGift: 'Group Gift',
      groupSize: 'Number of Contributors',
      categories: {
        Gift: 'Gift',
        TicketSale: 'Ticket Sale',
        Sponsorship: 'Sponsorship',
        Donation: 'Donation',
        Other: 'Other'
      }
    },
    expenses: {
      title: 'Expenses',
      addExpense: 'Add Expense',
      editExpense: 'Edit Expense',
      noEntries: 'No expense entries yet.',
      category: 'Category',
      vendor: 'Vendor / Supplier',
      description: 'Description',
      planned: 'Planned',
      actual: 'Actual',
      status: 'Payment Status',
      dueDate: 'Due Date',
      categories: {
        Venue: 'Venue',
        Catering: 'Catering',
        Decoration: 'Decoration',
        Photography: 'Photography',
        Entertainment: 'Entertainment',
        Marketing: 'Marketing',
        Transportation: 'Transportation',
        Accommodation: 'Accommodation',
        Other: 'Other'
      },
      paymentStatuses: {
        Planned: 'Planned',
        Paid: 'Paid',
        PartiallyPaid: 'Partially Paid'
      }
    },
    summary: {
      title: 'Financial Summary',
      incomeCard: 'Income',
      expensesCard: 'Expenses',
      resultCard: 'Result',
      plannedIncome: 'Planned Income',
      actualIncome: 'Actual Income',
      incomeVariance: 'Income Variance',
      plannedExpenses: 'Planned Expenses (budget)',
      entryPlannedExpenses: 'Planned Expenses (entries)',
      actualExpenses: 'Actual Expenses',
      expenseVariance: 'Expense Variance',
      profitLoss: 'Profit / Loss',
      budgetVariance: 'Budget Variance',
      guestInsights: 'Guest Insights',
      giftsCount: 'Gifts Received',
      totalGifts: 'Total Gifts',
      avgGift: 'Average Gift',
      incomePerAttendee: 'Income per Attendee',
      checkedIn: 'Checked-in Guests'
    },
    errors: {
      loadFailed: 'Failed to load finance data.',
      saveFailed: 'Failed to save. Please try again.'
    }
  },
  eventMediaPage: {
    title: 'Media',
    mediaButton: 'Media',
    description: 'Collect photos and videos for this event.',
    upload: 'Upload',
    empty: 'No photos or videos yet.',
    premiumRequired: 'Uploading event media is a Premium feature.',
    upgradeNow: 'Upgrade Now',
    select: 'Select',
    cancelSelect: 'Cancel',
    downloadAll: 'Download All',
    downloadSelected: 'Download Selected ({{count}})',
    uploadedBy: 'From: {{name}}',
    errors: {
      loadFailed: 'Failed to load media.',
      uploadFailed: 'Failed to upload file. Please try again.',
      deleteFailed: 'Failed to delete file. Please try again.',
      downloadFailed: 'Failed to download file. Please try again.',
      downloadZipFailed: 'Failed to download files. Please try again.'
    }
  },
  eventGalleryPage: {
    title: 'Guest Gallery',
    galleryButton: 'Guest Gallery',
    description: 'Let your guests share their own photos and videos after the event using one shared link.',
    notEnabled: 'The guest gallery is not enabled yet for this event.',
    enable: 'Enable Guest Gallery',
    enabling: 'Enabling...',
    linkLabel: 'Gallery link',
    copyLink: 'Copy link',
    linkCopied: 'Link copied to clipboard.',
    expiresLabel: 'Guests can upload until',
    send: 'Send link to guests',
    sending: 'Sending...',
    sendSuccess: 'Gallery link sent to {{count}} guest(s).',
    premiumRequired: 'The guest gallery is a Premium feature.',
    upgradeNow: 'Upgrade Now',
    disable: 'Disable Gallery',
    disabling: 'Disabling...',
    disabledNotice: 'The guest gallery is currently disabled. Guests can no longer view or upload photos.',
    reEnable: 'Re-enable Gallery',
    viewModeAllPhotos: 'Guests can view all photos',
    errors: {
      loadFailed: 'Failed to load gallery settings.',
      enableFailed: 'Failed to enable the guest gallery. Please try again.',
      sendFailed: 'Failed to send the gallery link. Please try again.',
      disableFailed: 'Failed to disable the guest gallery. Please try again.',
      viewModeFailed: 'Failed to update the viewing setting. Please try again.'
    }
  },
  eventWishlistPage: {
    title: 'Gift Wishlist',
    wishlistButton: 'Gift Wishlist',
    description: 'Add gifts guests can choose to bring. Guests who confirm attendance get a link to this list by email.',
    addItem: 'Add Gift',
    editItem: 'Edit Gift',
    empty: 'No gifts added yet.',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    addSuccess: '"{{name}}" was added to the wishlist.',
    updateSuccess: '"{{name}}" was updated.',
    deleteSuccess: '"{{name}}" was removed from the wishlist.',
    deleteConfirmTitle: 'Remove gift?',
    deleteConfirmMessage: 'Are you sure you want to remove "{{name}}" from the wishlist?',
    table: {
      name: 'Name',
      description: 'Description',
      link: 'Link',
      status: 'Status',
      reservedBy: 'Reserved by'
    },
    status: {
      available: 'Available',
      pending: 'Pending confirmation',
      confirmed: 'Reserved'
    },
    form: {
      name: 'Gift name',
      description: 'Short description',
      purchaseUrl: 'Purchase link'
    },
    errors: {
      loadFailed: 'Failed to load the wishlist.',
      saveFailed: 'Failed to save the gift. Please try again.',
      deleteFailed: 'Failed to remove the gift. Please try again.'
    }
  },
  publicGallery: {
    title: 'Guest Gallery',
    loading: 'Loading gallery...',
    subtitle: 'Photos and videos shared by guests of {{eventTitle}}',
    expiresNotice: 'Guests can add photos/videos until {{date}}.',
    expiredNotice: 'This gallery is no longer accepting new uploads, but you can still view what was shared.',
    disabledNotice: 'This gallery has been closed by the host.',
    ownUploadsNotice: "You're only seeing the photos and videos you uploaded from this device.",
    uploaderLabelPlaceholder: 'Your name (optional)',
    upload: 'Add photo/video',
    uploading: 'Uploading...',
    uploadDisclaimer: 'By uploading here, your photo or video becomes visible to all guests of this event. Please make sure you have consent from anyone shown in your content. The organizer can remove any item at any time.',
    empty: 'No photos or videos yet. Be the first to share!',
    uploadedBy: 'From: {{name}}',
    errors: {
      backendUnavailable: 'Cannot reach backend API at {{baseUrl}}. Start API with: dotnet run --project src/Backend/EventList.Api',
      invalidGallery: 'This gallery link is invalid or has expired.',
      loadGallery: 'Unable to load this gallery right now.',
      uploadFailed: 'Failed to upload file. Please try again.'
    }
  },
  publicWishlist: {
    title: 'Gift Wishlist',
    loading: 'Loading wishlist...',
    subtitle: 'Gift ideas for {{eventTitle}}',
    empty: 'No gifts have been added yet.',
    viewLink: 'View gift',
    reserve: "I'll bring this",
    reserving: 'Reserving...',
    release: 'Cancel my reservation',
    releasing: 'Cancelling...',
    reservedByMe: "You've claimed this gift. Check your email to confirm within 60 minutes.",
    confirmedByMe: "You've confirmed this gift. Thank you!",
    unavailable: 'Already claimed by another guest',
    attendingRequiredNotice: 'Only guests who confirmed attendance can reserve a gift.',
    errors: {
      backendUnavailable: 'Cannot reach backend API at {{baseUrl}}. Start API with: dotnet run --project src/Backend/EventList.Api',
      invalidInvitation: 'This link is invalid or has expired.',
      loadFailed: 'Unable to load the wishlist right now.',
      reserveFailed: 'Unable to reserve this gift right now. It may have just been claimed by someone else.',
      releaseFailed: 'Unable to cancel your reservation right now.'
    }
  },
  publicWishlistConfirm: {
    title: 'Confirm your gift reservation',
    confirming: 'Confirming your reservation...',
    successTitle: 'Reservation confirmed!',
    successMessage: 'Thank you! Your reservation for "{{itemName}}" is confirmed.',
    failureTitle: 'This link is no longer valid',
    backToWishlist: 'Back to the wishlist'
  }
};

export default en;
